import { STATUS_TYPE } from '../../../enum';
import { Shape } from '../../shape/api/interface';

export interface ReadImageItems {
  shapeId: string;
  // sliced: string;
  top: string;
  front: string;
  shape: Shape;
}

export interface ImageItems {
  shapeId: string;
  // sliced: string;
  top: string;
  front: string;
}

export interface FindFlavor {
  limit?: number;
  skip?: number;
  search?: string;
  isExport?: boolean;
}

export interface GetFlavor {
  id: string;
}

export interface CreatePatchFlavor {
  id?: string;
  labelEn: string;
  labelAr: string;
  code: string;
  subLabelEn: string;
  subLabelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  previewUrl: string;
  pricePerKg: string;
  position: string;
  imageItems: ImageItems[];
  // isNew: boolean;
  activeState: boolean;
}

export interface Flavor {
  id: string;
  labelEn: string;
  labelAr: string;
  code: string;
  subLabelEn: string;
  subLabelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  previewUrl: string;
  pricePerKg: string;
  position: string;
  shapeImages: ReadImageItems[];
  // isNew: boolean;
  activeState: boolean;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
}

export interface InitialState {
  data: Flavor[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
